export var JobStatus;
(function (JobStatus) {
    JobStatus["Assigned"] = "assigned";
    JobStatus["InProgress"] = "inProgress";
    JobStatus["Done"] = "done";
    JobStatus["Completed"] = "completed";
    JobStatus["Canceled"] = "canceled";
    JobStatus["Suspended"] = "suspended";
    JobStatus["Unassigned"] = "unassigned";
})(JobStatus || (JobStatus = {}));
export var JobType;
(function (JobType) {
    JobType["Hourly"] = "hourly";
    JobType["PerFoot"] = "perfoot";
    JobType["Bid"] = "Bid";
    JobType["Unit"] = "Unit";
})(JobType || (JobType = {}));
export var WorkOrderType;
(function (WorkOrderType) {
    WorkOrderType["Maintenance"] = "maintenance";
    WorkOrderType["NewConstruction"] = "newConstruction";
})(WorkOrderType || (WorkOrderType = {}));
export var JobCategory;
(function (JobCategory) {
    JobCategory["OHElectric"] = "OH Electric";
    JobCategory["UGGas"] = "UG Gas";
    JobCategory["UGElectric"] = "UG Electric";
    JobCategory["CastIronWork"] = "Cast Iron Work";
    JobCategory["OverheadWork"] = "Overhead Work";
    JobCategory["General"] = "General";
})(JobCategory || (JobCategory = {}));
//# sourceMappingURL=jobModel.js.map